/*eslint-disable*/
import React, { useState } from 'react';
import classes from './PropertyRequests.module.css';
import SideBarSkeleton from '../../../Component/SideBarSkeleton';
import { Col, Container, Row } from 'react-bootstrap';
import CustomMaterialTable from '../../../Component/CustomMaterialTable';
import { AiFillEye } from 'react-icons/ai';
import SearchInput from '../../../Component/SearchInput';
import { recordsLimit } from '../../../config/apiUrl';
import Button from '../../../Component/Button/Button';
import useDebounce from '../../../CustomHooks/useDebounce';
import {
  useDeletePropertyRequestsMutation,
  useGetAllInquiryMessageAndRequestQuery,
  useGetAllPropertyRequestsQuery
} from '../../../store/apiSlice/apiSlice';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import PropertyRequestDetailModal from '../../../modals/PropertyRequestDetailModal';
import Tabs from '../../../Component/Tabs';
import { FaCircleNotch } from 'react-icons/fa';
import { useSelector } from 'react-redux';

function PropertyRequests() {
  const { t } = useTranslation('dashboardPropertyRequests');

  const { user } = useSelector((state) => state?.authReducer);
  const [searchText, setSearchText] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [limit, setLimit] = useState(recordsLimit);
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);

  const tabsData = [
    {
      icon: <FaCircleNotch />,
      text: t('propertyRequests'),
      id: 1,
      type: 'property-request'
    },
    {
      icon: <FaCircleNotch />,
      text: t('inquiry'),
      id: 2,
      type: 'inquiry'
    },
    {
      icon: <FaCircleNotch />,
      text: t('message'),
      id: 3,
      type: 'inquiry'
    }
  ];
  const [selectedTab, setSelectedTab] = useState(tabsData[0]);

  const debounceSearch = useDebounce(searchText, 500);
  const { data, isLoading, isFetching } = useGetAllPropertyRequestsQuery(
    {
      limit: recordsLimit,
      page: page,
      search: debounceSearch
    },
    {
      // skip: selectedTab?.text !== 'Property Requests' || 'propertyRequests'
      skip: selectedTab?.type !== 'property-request'
    }
  );
  const {
    data: inquiryData,
    isLoading: isLoadingInquiryMessage,
    isFetchingInquiryMessage
  } = useGetAllInquiryMessageAndRequestQuery(
    {
      limit: recordsLimit,
      page: page,
      search: debounceSearch,
      type: selectedTab?.text?.toLowerCase()
    },
    {
      // skip: selectedTab?.text == 'Property Requests' || 'propertyRequests'
      skip: selectedTab?.type == 'property-request'
    }
  );

  // headings
  const headings = [
    { id: 'id', label: t('table.col1'), renderValue: (_, __, i) => i + 1 },
    { id: selectedTab.id == 1 ? 'fullName' : 'name', label: t('table.col2') }, //name
    { id: 'email', label: t('table.col3') }, // message, preferredContactMethod, entity, createdBy
    {
      id: selectedTab.id == 1 ? 'phoneNo' : 'phone',
      label: t('table.col4'),
      renderValue: (e) => e?.phoneNumber || e?.phone
    },
    ...(selectedTab.id == 1
      ? [
          {
            id: 'budget',
            label: t('table.col5'),
            renderValue: (e) => `$${e?.budget}`
          }
        ]
      : []),

    {
      id: 'seen',
      label: t('table.col7'),
      renderValue: (e) => (isSeen(e) ? t('seen') : t('unseen'))
    },
    { id: 'options', label: t('table.col6'), align: 'center' }
  ];

  const [deleteRecordsApi, { isLoading: isDeleting }] = useDeletePropertyRequestsMutation();
  //  delete api
  const deleteMultiple = async () => {
    const res = await deleteRecordsApi({
      ids: selectedRows?.map((item) => item._id),
      type: selectedTab?.type
    });
    if (res?.data) {
      toast.success(
        `${t('toast.item')} ${selectedRows?.length > 1 ? t('toast.s') : ''} ${t(
          'toast.deletedSuccessfully'
        )}.`
      );
      setSelectedRows([]);
    }
  };

  // check if data is seen
  const isSeen = (data) => {
    if (Array.isArray(data?.seenBy)) {
      return data?.seenBy.includes(user?._id);
    }
    if (data?.seen === true) {
      return true;
    }
    return false;
  };

  return (
    <SideBarSkeleton>
      <Container fluid className={classes.page}>
        <Row>
          <Col md={12} className={classes.mb58}>
            <div className={classes.header}>
              <SearchInput
                placeholder={t('searchByName')}
                setter={setSearchText}
                state={searchText}
                variant="dashboard"
                className={classes.searchClass}
                containerStyle={{ overflowY: 'hidden' }}
              />
              <Button
                borderRadius={'8px'}
                className={classes.deleteBtn}
                disabled={selectedRows?.length == 0 || isDeleting}
                onClick={deleteMultiple}
                label={isDeleting ? t('deleting') : t('delete')}
              />
            </div>
          </Col>
          <Col md={12}>
            <h5 className={classes.heading}>{t('title')}</h5>
          </Col>
          <Col md={12} className={classes.tabCol}>
            <Tabs
              selectedTabClass={classes?.selectedTabColor}
              selectedColor="var(--btn-secondary-color)"
              tabsData={tabsData}
              value={selectedTab}
              tabClass={classes.tab}
              setValue={(tab) => {
                setSelectedTab(tab);
                setPage(1);
                setSearchText('');
              }}
              className={classes.tabClass}
            />
          </Col>
          <Col md={12}>
            <CustomMaterialTable
              headings={headings}
              data={selectedTab.id == 1 ? data?.data : inquiryData?.data}
              page={page}
              setPage={setPage}
              isLoading={
                isLoading || isFetching || isLoadingInquiryMessage || isFetchingInquiryMessage
              }
              showOptionsColumn
              optionsToggle={false}
              options={[]}
              onOptionClick={() => {}}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
              totalRecords={Math.ceil(data?.totalRecords / recordsLimit)}
              allowMultipleSelection
              rowsPerPage={limit}
              setRowsPerPage={setLimit}
              setSelectedItemParent={setSelectedItem}
              setShowModalParent={setShowModal}
            />
          </Col>
        </Row>

        {showModal == 'detail' && (
          <PropertyRequestDetailModal
            data={selectedItem}
            show={showModal == 'detail'}
            setShow={setShowModal}
            isSeen={isSeen(selectedItem)}
            type={selectedTab.type}
            t={t}
          />
        )}
      </Container>
    </SideBarSkeleton>
  );
}

export default PropertyRequests;
